module.exports = __webpack_public_path__ + "img/612-img-1b@2x.a7d79a59.jpg";